import React from "react";
import { Box, Backdrop } from "@mui/material";
import { useLoading } from "../../contexts/LoadingContext";
import YarnBallLoader from "./YarnBallLoader";

const LoadingOverlay = () => {
  const { isLoading, loadingStates } = useLoading();

  // Determine the appropriate message based on what's loading
  const getLoadingMessage = () => {
    if (loadingStates.chart) return "Generating chart...";
    if (loadingStates.api) return "Loading data...";
    if (loadingStates.app) return "Loading application...";
    return "Loading...";
  };

  if (!isLoading) return null;

  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(244, 239, 232, 0.8)",
        backdropFilter: "blur(4px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <YarnBallLoader size={80} speed={1.0} label={getLoadingMessage()} />
      </Box>
    </Backdrop>
  );
};

export default LoadingOverlay;
